import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../lib/assets";
import { PaisleyDivider } from "./Motifs";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-ink-900 pt-24">
      <PaisleyDivider className="mb-16" />

      <div className="mx-auto max-w-wide px-6 sm:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt="Zaya & Zari" className="h-12 w-12 object-contain" />
              <span className="font-display text-2xl tracking-[0.18em] text-cream-50">
                ZAYA <span className="text-gold">&amp;</span> ZARI
              </span>
            </div>
            <p className="mt-6 max-w-sm text-cream-50/60 leading-relaxed">
              A full-service luxury beauty atelier where royal Indian heritage is
              woven with earthy, modern artistry. Threads of gold, rooted in soul.
            </p>
            <div className="mt-6 flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold transition-colors hover:bg-gold hover:text-ink-900"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold transition-colors hover:bg-gold hover:text-ink-900"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="overline text-gold">Explore</h4>
            <ul className="mt-6 flex flex-col gap-3">
              {["Home", "Services", "About", "Gallery", "Contact"].map((l) => (
                <li key={l}>
                  <Link
                    to={l === "Home" ? "/" : `/${l.toLowerCase()}`}
                    className="link-underline text-cream-50/70 hover:text-cream-50"
                  >
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="overline text-gold">Visit Us</h4>
            <ul className="mt-6 flex flex-col gap-4 text-cream-50/70">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-1 shrink-0 text-gold" />
                <span>14 Heritage Lane, Jaipur, Rajasthan 302001</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="shrink-0 text-gold" />
                <a href="tel:+919000000000" className="link-underline">+91 90000 00000</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="shrink-0 text-gold" />
                <a href="mailto:hello@zayazari.com" className="link-underline">
                  hello@zayazari.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 overflow-hidden">
          <h2 className="select-none whitespace-nowrap font-display text-[18vw] font-light leading-none tracking-tight text-cream-50/[0.06] md:text-[14vw]">
            ZAYA &amp; ZARI
          </h2>
        </div>

        <div className="gold-rule" />
        <div className="flex flex-col items-center justify-between gap-3 py-8 text-xs uppercase tracking-[0.2em] text-cream-50/40 sm:flex-row">
          <span>© {new Date().getFullYear()} Zaya &amp; Zari Atelier</span>
          <span>Crafted with heritage &amp; heart</span>
        </div>
      </div>
    </footer>
  );
}
